// extracted by mini-css-extract-plugin
var _1 = "socialMediaButton-module__socialMediaButton___Peoiq";
export { _1 as "socialMediaButton" }
